module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": 'main-form-' + this.group
    }
  }, [_c('fieldset', [_c('legend', [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Dados Gerais\n          "), (_vm.sales.length > 0) ? _c('span', [(typeof(_vm.sales[0].nf) === 'object') ? _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "padding": "4px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.emitNFE($event)
      }
    }
  }, [_vm._v("\n              Emitir Nota Fiscal\n            ")]) : _vm._e(), _vm._v(" "), (typeof(_vm.sales[0].nf) === 'string') ? _c('a', {
    staticClass: "btn btn-success pull-right",
    staticStyle: {
      "padding": "4px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.emitNFE($event)
      }
    }
  }, [_vm._v("\n              Imprimir DANFE\n            ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.__fields), function(field) {
    return [(field.name !== 'mean_price' || (field.name == 'mean_price' && _vm.profile.map['vehicle-entries'].includes('show-acquisition-price'))) ? _c(_vm.checkComponentType(field), {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "lazy": field.lazy,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "order-by": field.orderBy,
        "has-related": field.hasRelated,
        "related": field.related,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.getReadonlyStateField(field) || _vm.unidadesDiferentes,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[_vm.getKeyValue(field)]),
        callback: function($$v) {
          _vm.$set(_vm.$data, _vm.getKeyValue(field), $$v)
        },
        expression: "$data[getKeyValue(field)]"
      }
    }) : _vm._e()]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5da1484"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/VehicleEntry/Edit/EditForm.vue
// module id = 1076
// module chunks = 1